import { HrHeart, HrSave, HrSteamingBowl } from '@hungryroot/ui-kit';

export const VALUE_PROPOSITIONS = [
  {
    icon: <HrSave />,
    text: 'Save time, money and hassle',
  },
  {
    icon: <HrSteamingBowl />,
    text: 'Discover delicious new-to-you foods',
  },
  {
    icon: <HrHeart />,
    text: 'Enjoy healthy eats that meet your needs',
  },
];
